// Faithful V2 reimplementation of legacy v1's `CountSection`
// (CreateGigOrder/.../StaffingStep/Common/StaffingUtils.tsx). We
// deliberately re-implement it here instead of importing the v1 helper:
// the v1 component pulls in graphql-typed props and shared <Text>, and
// must not be modified. This renders the exact same strings/colors so
// the v2 shift drill-in modal subtitle matches v1 verbatim.
//
// v1 logic preserved exactly:
//   fullyStaffed = hiredCount > 0 && hiredCount === quantity (caller)
//   LTA:                 "{hired} of {q} Hired"   [+ " | Fully Staffed"]
//   non-LTA tenant adm:  "{hired} of {q} Hired | {invited} Invited"
//                        (Invited segment blanked when fully staffed,
//                         replaced by a green "Fully Staffed")
//   non-LTA client adm:  "{invited} of {q} Invited"

const FULLY_STAFFED_GREEN = '#45A735';

type ShiftCountLabelProps = {
  isLta: boolean;
  isClientAdmin: boolean;
  hiredCount: number;
  invitedCount: number;
  quantity?: number;
  fullyStaffed: boolean;
};

const ShiftCountLabel = ({
  isLta,
  isClientAdmin,
  hiredCount,
  invitedCount,
  quantity,
  fullyStaffed,
}: ShiftCountLabelProps) => {
  const q = quantity ?? 0;

  if (isLta) {
    return (
      <>
        {`${hiredCount} of ${q} Hired`}
        {fullyStaffed && (
          <span style={{ color: FULLY_STAFFED_GREEN }}>
            {' | Fully Staffed'}
          </span>
        )}
      </>
    );
  }

  return (
    <>
      {!isClientAdmin &&
        `${hiredCount} of ${q} Hired | ${
          !fullyStaffed ? `${invitedCount} Invited` : ''
        }`}
      {fullyStaffed && (
        <span style={{ color: FULLY_STAFFED_GREEN }}>{'Fully Staffed'}</span>
      )}
      {isClientAdmin && `${invitedCount} of ${q} Invited`}
    </>
  );
};

export default ShiftCountLabel;
